module.exports = __webpack_public_path__ + "static/media/10.87ea6dac.jpg";